import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { EffectCoverflow, Pagination, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import { Imgs } from "../../img/Imgs/Imgs";
import { useSelector } from "react-redux";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";


export default function SliderInv() {
    const selectedLanguages = useSelector(selectedLanguage);
    const invitationSlides = [
      {
        to: "/templates/invitations/wedding",
        src: Imgs.invitationwedding,
        label: translations[selectedLanguages]?.templatesMain?.wedding,
      },
      {
        to: "/templates/invitations/engagement",
        src: Imgs.invitationengagement,
        label: translations[selectedLanguages]?.templatesMain?.engagement,
      },
      {
        to: "/templates/invitations/birthday",
        src: Imgs.invitationbirthday,
        label: translations[selectedLanguages]?.templatesMain?.birthday,
      },
      {
        to: "/templates/invitations/christening",
        src: Imgs.invitationchristening,
        label: translations[selectedLanguages]?.templatesMain?.christening,
      },
      {
        to: "/templates/invitations/others",
        src: Imgs.invitationothers,
        label: translations[selectedLanguages]?.templatesMain?.others,
      },
      {
        to: "/templates/invitations/wedding",
        src: Imgs.invitationwedding,
        label: translations[selectedLanguages]?.templatesMain?.wedding,
      },
      {
        to: "/templates/invitations/engagement",
        src: Imgs.invitationengagement,
        label: translations[selectedLanguages]?.templatesMain?.engagement,
      },
      {
        to: "/templates/invitations/birthday",
        src: Imgs.invitationbirthday,
        label: translations[selectedLanguages]?.templatesMain?.birthday,
      },
      {
        to: "/templates/invitations/christening",
        src: Imgs.invitationchristening,
        label: translations[selectedLanguages]?.templatesMain?.christening,
      },
      {
        to: "/templates/invitations/others",
        src: Imgs.invitationothers,
        label: translations[selectedLanguages]?.templatesMain?.others,
      },
    ];

  return (
    <section className="slider-inv">
      <Swiper
        effect="coverflow"
        grabCursor={true}
        centeredSlides={true}
        slidesPerView="auto"
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        // pagination={{ clickable: true }}
        loop={true}
        speed={1000}
        modules={[EffectCoverflow, Pagination, Autoplay]}
        className="mySwiper"
      >
        {invitationSlides.map((item, index) => (
          <SwiperSlide className="swiper-slide-custom" key={index}>
            <Link to={item.to}>
              <img src={item.src} alt={item.label} />
              <span>{item.label}</span>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
